const measureStatus = (statusCode, statusName) => {
  if (statusCode === '100') {
    return `<span class="badge bg-yellow text-dark">${statusName}</span>`
  }
  if (statusCode === '150') {
    return `<span class="badge bg-warning">${statusName}</span>`
  }
  if (statusCode === '160') {
    return `<span class="badge bg-success">${statusName}</span>`
  }
  if (statusCode === '190') {
    return `<span class="badge bg-danger">${statusName}</span>`
  }
  if (statusCode === '191') {
    return `<span class="badge bg-danger">${statusName}</span>`
  }
  return '<span class="badge bg-info">Não Identificado</span>'
}

export { measureStatus }
